import { createContext } from 'react'

import type { ToggleButtonSize } from './toggle-button.styles'

export type ToggleGroupContextValue = {
  size: ToggleButtonSize
  layoutId: string
  single: boolean
  selectedValues: string[]
  disabled: boolean
  /**
   * The values a drag-select gesture can run over, which need marking in the DOM so the
   * gesture can measure them. Carried on the context rather than asked of every
   * consumer, so a caller cannot enable brushing and forget to mark the buttons — and
   * carried as the VALUES rather than a flag, so a neutral `Any` outside the gesture
   * does not advertise itself as part of it. Empty when the group does not brush.
   */
  brushValues: readonly string[]
  /**
   * Entries take the width their own label needs instead of an equal share of the row.
   * Carried on the context because the width is applied by each `ToggleButton`, and a
   * per-button prop would let one entry in a group opt out and break the row.
   */
  hug: boolean
}

export const ToggleButtonGroupContext = createContext<ToggleGroupContextValue | null>(null)
